<template>
  <button
    v-if="appStore.sidebarCollapsed"
    aria-label="展开侧栏"
    class="ai-sidebar-expand-button"
    title="展开侧栏"
    type="button"
    @click="appStore.setSidebarCollapsed(!appStore.sidebarCollapsed)"
  >
    <i aria-hidden="true" class="icon-layout-right-2-line t-iconfont"></i>
  </button>
</template>

<script setup>
import { useAppStore } from '@/store/useAppStore'

defineOptions({ name: 'AiSidebarExpandButton' })

const appStore = useAppStore()
</script>

<style lang="scss" scoped>
.ai-sidebar-expand-button {
  display: inline-flex;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #4d5563;
  cursor: pointer;

  .t-iconfont {
    font-size: 16px;
    line-height: 16px;
  }

  &:hover {
    // background: #eeeeee;
  }

  &:focus-visible {
    outline: 2px solid #7a52f4;
    outline-offset: -2px;
  }
}
</style>
